import { Box, styled } from "@mui/material";

type StyledProjectCardProps = {
  status: string;
};

export const StyledProjectCard = styled(Box)<StyledProjectCardProps>(
  ({ theme, status }) => ({
    height: "9rem",
    border: `3px solid ${
      status === "Finished"
        ? theme.palette.success.main
        : status === "InProgress"
          ? theme.palette.warning.main
          : status === "Rejected"
            ? theme.palette.error.main
            : status === "QuoteSent"
              ? theme.color.main
              : theme.contrast.lighter
    }`,
    borderRadius: "15px",
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gridTemplateRows: "repeat(8, 1fr)",
    ".iconWrapper": {
      gridArea: "3 / 1 / 5 / 3",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: theme.color.dark,
    },
    ".infoWrapper": {
      gridArea: "1 / 3 / 8 / 13",
      h3: {
        color: theme.color.dark,
        fontWeight: "bold",
        textTransform: "",
      },
    },
    ".buttonWrapper": {
      gridArea: "1 / 11 / 3 / 13",
      padding: ".5rem",
      display: "flex",
      justifyContent: "flex-end",
      button: {
        height: "min-content",
        padding: ".25rem",
        boxSizing: "border-box",
        margin: "0",
        minWidth: "min-content",
      },
    },
    ".footer": {
      gridArea: "8 / 1 / 9 / 13",
      paddingRight: "1rem",
      display: "flex",
      justifyContent: "space-between",
      color: theme.contrast.main,
      padding: "1rem",
    },
    [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
      height: "8rem",
      ".iconWrapper svg": {
        width: "2.5rem",
      },
      ".infoWrapper": {
        h3: {
          fontSize: "1.5rem",
        },
      },
    },
  }),
);
